import { Box, Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import { VideoDetailsView } from "../../../../VideoSuite/Components/Shared/VideoSuiteHelper";
import VideoSuiteHistoryCard from "../../../../VideoSuite/VideoSuiteHistory/Components/VideoSuiteHistoryCard";
import VideoSuiteHistoryDetailsModal from "../../../../VideoSuite/VideoSuiteHistory/Components/VideoSuiteHistoryDetailsModal";
import { videoLibraryItem } from "../../../InspirationLibraryHelper";
import { VideoSuiteApps } from "../../../../../Helper";
import VideoLibraryCard from "./VideoLibraryCard";

interface VideoLibraryItemsProps {
  activeCategory: number;
  videoLibraryItems: videoLibraryItem[];
}

export const VideoLibraryItems = ({
  activeCategory,
  videoLibraryItems,
}: VideoLibraryItemsProps) => {
  const [selectedVideoLibraryId, setSelectedVideoLibraryId] = useState("");
  const [selectedVideoLibrary, setSelectedVideoLibrary] =
    useState<videoLibraryItem | null>(null);
  const [openVideoLibraryItemModal, setOpenVideoLibraryItemModal] =
    useState(false);

  const handleOpenVideoLibraryModal = (videoId: string) => {
    setSelectedVideoLibraryId(videoId);
    setOpenVideoLibraryItemModal(true);
  };

  const handleCloseVideoLibraryModal = () =>
    setOpenVideoLibraryItemModal(false);

  const handleSelectVideoLibrary = (video: videoLibraryItem) => {
    setSelectedVideoLibrary(video);
  };

  // Intersection Observer to add fade-up scroll animation effect.
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".fade-up");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [activeCategory, videoLibraryItems]);

  return (
    <>
      <Box className="library-items">
        <Box className="library-items-container">
          <div className="masonry-grid">
            {videoLibraryItems?.map((video, i) => (
              <div
                key={i}
                className="masonry-item fade-up"
                onClick={() => handleSelectVideoLibrary(video)}
              >
                <VideoLibraryCard
                  key={video.fileName}
                  videoData={{
                    id: video.fileName,
                    output: video.url,
                    appType: VideoSuiteApps.VideoGenerator,
                    createdAt: ""
                  }}
                  handleOpenVideoHistoryDetailsModal={
                    handleOpenVideoLibraryModal
                  }
                  showVideoOptions={{
                    delete: false,
                    share: false,
                    download: false,
                  }}
                  cardView={VideoDetailsView.library}
                />
              </div>
            ))}
          </div>
        </Box>
      </Box>
      {openVideoLibraryItemModal && (
        <Modal
          open={openVideoLibraryItemModal}
          onClose={handleCloseVideoLibraryModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <VideoSuiteHistoryDetailsModal
            videoId={selectedVideoLibraryId}
            handleCloseModal={handleCloseVideoLibraryModal}
            setIsFireRegenerate={() => {}}
            view={VideoDetailsView.library}
            btnActionText="Generate similar video"
            videoLibraryData={selectedVideoLibrary}
          />
        </Modal>
      )}
    </>
  );
};
